import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
export var dashboardRoutes = [
    {
        path: 'dashboard',
        component: DashboardListComponent
    },
    {
        path: 'dashboard-it',
        component: DashboardForItComponent
    }
];
var DashboardRoutingModule = (function () {
    function DashboardRoutingModule() {
    }
    return DashboardRoutingModule;
}());
export { DashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-routing.module.ts.pre-build-optimizer.js